module.exports = __webpack_public_path__ + "img/HYPRBrandDesignSystem_Hero.810d8350.jpg";